/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDealerDetailsHeader_seller = {
    readonly monthsSinceStartDate: number | null;
    readonly sellerProfile: {
        readonly company: string | null;
    } | null;
    readonly " $refType": "PdpSharedDealerDetailsHeader_seller";
};
export type PdpSharedDealerDetailsHeader_seller$data = PdpSharedDealerDetailsHeader_seller;
export type PdpSharedDealerDetailsHeader_seller$key = {
    readonly " $data"?: PdpSharedDealerDetailsHeader_seller$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDealerDetailsHeader_seller">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedDealerDetailsHeader_seller",
  "type": "Seller",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "monthsSinceStartDate",
      "name": "timeSinceStartDate",
      "args": [
        {
          "kind": "Literal",
          "name": "unit",
          "value": "MONTH"
        }
      ],
      "storageKey": "timeSinceStartDate(unit:\"MONTH\")"
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "sellerProfile",
      "storageKey": null,
      "args": null,
      "concreteType": "SellerProfile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "company",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = '854a1041998f4df01e6186b6397ac187';
export default node;
